<admin-app-header></admin-app-header>
<div class="container-fluid admyt-page">
    <!-- Header with navigation -->
    <div class="row my-3">
        <div class="col-md-8">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <a [routerLink]="['/admin/admyt-centers']">Admyt Centers</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                        {{ center?.name || centerId }}
                    </li>
                </ol>
            </nav>
        </div>
        <div class="col-md-4 text-end">
            <button class="admyt-btn-secondary" (click)="refreshData()" [disabled]="loading">
                <i class="fa-solid fa-refresh" [class.fa-spin]="loading"></i> Refresh
            </button>
        </div>
    </div>

    <!-- Loading state -->
    <div *ngIf="loading" class="text-center my-5">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
        <p class="mt-2">Loading center details...</p>
    </div>

    <!-- Error state -->
    <div *ngIf="error" class="alert alert-danger">
        {{ error }}
        <button (click)="refreshData()" class="btn btn-outline-danger btn-sm ms-2">Try Again</button>
    </div>

    <!-- Center details -->
    <div *ngIf="!loading && !error && center">
        <!-- Stat Cards -->
        <div class="admyt-stat-cards">
            <div class="admyt-stat-card admyt-stat-card--purple">
                <span class="data-source data-source--admyt"><i class="fa-solid fa-cloud"></i> Admyt</span>
                <div class="admyt-stat-card__icon">
                    <i class="fa-solid fa-building"></i>
                </div>
                <div class="admyt-stat-card__content">
                    <span class="admyt-stat-card__label">Center</span>
                    <span class="admyt-stat-card__value">{{ center.name }}</span>
                </div>
            </div>
            
            <div class="admyt-stat-card admyt-stat-card--blue">
                <span class="data-source data-source--parkupp"><i class="fa-solid fa-database"></i> ParkUpp</span>
                <div class="admyt-stat-card__icon">
                    <i class="fa-solid fa-square-parking"></i>
                </div>
                <div class="admyt-stat-card__content">
                    <span class="admyt-stat-card__label">Linked Parkings</span>
                    <span class="admyt-stat-card__value">{{ relatedParkings.length }}</span>
                </div>
            </div>
            
            <div class="admyt-stat-card admyt-stat-card--teal">
                <span class="data-source data-source--admyt"><i class="fa-solid fa-cloud"></i> Admyt</span>
                <div class="admyt-stat-card__icon">
                    <i class="fa-solid fa-id-card"></i>
                </div>
                <div class="admyt-stat-card__content">
                    <span class="admyt-stat-card__label">Tenants</span>
                    <span class="admyt-stat-card__value">{{ relatedTenants.length }}</span>
                </div>
            </div>
            
            <div class="admyt-stat-card admyt-stat-card--green">
                <span class="data-source data-source--admyt"><i class="fa-solid fa-cloud"></i> Admyt</span>
                <div class="admyt-stat-card__icon">
                    <i class="fa-solid fa-layer-group"></i>
                </div>
                <div class="admyt-stat-card__content">
                    <span class="admyt-stat-card__label">Zones</span>
                    <span class="admyt-stat-card__value">{{ center.zones?.length || 0 }}</span>
                </div>
            </div>
        </div>

        <!-- Center Information Card -->
        <div class="admyt-card">
            <div class="admyt-card__header">
                <h3>
                    <i class="fa-solid fa-building me-2"></i>
                    Center Details
                    <span class="data-source data-source--admyt"><i class="fa-solid fa-cloud"></i> Admyt</span>
                </h3>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <dl class="row mb-0">
                        <dt class="col-sm-4">Center ID:</dt>
                        <dd class="col-sm-8">
                            <code>{{ center.id }}</code>
                        </dd>

                        <dt class="col-sm-4">Name:</dt>
                        <dd class="col-sm-8">
                            <strong>{{ center.name }}</strong>
                        </dd>
                    </dl>
                </div>
                <div class="col-md-6">
                    <dl class="row mb-0">
                        <dt class="col-sm-4" *ngIf="center.zones && center.zones.length > 0">Zones:</dt>
                        <dd class="col-sm-8" *ngIf="center.zones && center.zones.length > 0">
                            <span *ngFor="let zone of center.zones" class="admyt-status admyt-status--active me-1">
                                {{ zone }}
                            </span>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>

        <!-- Related Parkings -->
        <div class="admyt-card">
            <div class="admyt-card__header">
                <h4>
                    <i class="fa-solid fa-square-parking me-2"></i>
                    Related Parkings
                    <span class="admyt-status admyt-status--active ms-2">{{ relatedParkings.length }}</span>
                    <span class="data-source data-source--parkupp ms-2"><i class="fa-solid fa-database"></i> ParkUpp</span>
                </h4>
            </div>

            <!-- Parkings loading state -->
            <div *ngIf="parkingsLoading" class="text-center py-4">
                <i class="fa fa-spinner fa-spin"></i>
                Loading parkings...
            </div>

            <!-- No parkings message -->
            <div *ngIf="!parkingsLoading && relatedParkings.length === 0" class="text-center py-5">
                <i class="fa-solid fa-square-parking fa-2x text-muted"></i>
                <p class="mt-2 text-muted">No parkings are currently linked to this center.</p>
                <small class="text-muted">
                    Parkings can be linked by setting their "Admyt Center" field to <code>{{ center.id }}</code>
                </small>
            </div>

            <!-- Parkings table -->
            <div *ngIf="!parkingsLoading && relatedParkings.length > 0" class="table-responsive">
                <table class="admyt-table">
                    <thead>
                        <tr>
                            <th>Parking Name</th>
                            <th>Location</th>
                            <th>Merchant</th>
                            <th>Bays</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let parking of relatedParkings">
                            <td>
                                <a [routerLink]="['/parking', parking.$key]" class="admyt-link">
                                    <i class="fa-solid fa-square-parking"></i>
                                    {{ parking.title || 'Unnamed Parking' }}
                                </a>
                            </td>
                            <td>
                                <span *ngIf="parking.parkingLocation?.city">
                                    <i class="fa-solid fa-location-dot me-1 text-muted"></i>
                                    {{ parking.parkingLocation.city }}
                                    <span *ngIf="parking.parkingLocation.suburb">, {{ parking.parkingLocation.suburb }}</span>
                                </span>
                                <span *ngIf="!parking.parkingLocation?.city" class="text-muted">No location</span>
                            </td>
                            <td>
                                <a *ngIf="parking.merchantRef" [routerLink]="['/merchant', parking.merchantRef.id]" class="admyt-link">
                                    {{ parking.denormMerchantCompanyName || 'Unknown' }}
                                </a>
                            </td>
                            <td>
                                <span *ngIf="parking.numberOfBays" class="admyt-status admyt-status--active">
                                    {{ parking.numberOfBays }} bays
                                </span>
                            </td>
                            <td>
                                <span [class]="getStatusClass(parking.parkingStatus)">
                                    {{ parking.parkingStatus }}
                                </span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <a [routerLink]="['/parking', parking.$key]" class="btn btn-outline-primary btn-sm" title="View parking">
                                        <i class="fa-solid fa-eye"></i>
                                    </a>
                                    <a [routerLink]="['/merchant', parking.merchantRef?.id, 'parking', parking.$key]" class="btn btn-outline-secondary btn-sm" title="Edit parking">
                                        <i class="fa-solid fa-edit"></i>
                                    </a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Related Tenants -->
        <div class="admyt-card">
            <div class="admyt-card__header">
                <h4>
                    <i class="fa-solid fa-id-card me-2"></i>
                    Tenants
                    <span class="admyt-status admyt-status--active ms-2">{{ relatedTenants.length }}</span>
                    <span class="data-source data-source--admyt ms-2"><i class="fa-solid fa-cloud"></i> Admyt</span>
                </h4>
                <button class="admyt-btn-primary" (click)="showCreateTenantUserModal()">
                    <i class="fa-solid fa-plus"></i> Add Tenant User
                </button>
            </div>

            <!-- Tenants loading state -->
            <div *ngIf="tenantsLoading" class="text-center py-4">
                <i class="fa fa-spinner fa-spin"></i>
                Loading tenants...
            </div>

            <!-- No tenants message -->
            <div *ngIf="!tenantsLoading && relatedTenants.length === 0" class="text-center py-5">
                <i class="fa-solid fa-id-card fa-2x text-muted"></i>
                <p class="mt-2 text-muted">No tenants are currently registered in this center.</p>
            </div>

            <!-- Tenants table -->
            <div *ngIf="!tenantsLoading && relatedTenants.length > 0" class="table-responsive">
                <table class="admyt-table">
                    <thead>
                        <tr>
                            <th>Tenant ID</th>
                            <th>Name</th>
                            <th>Linked Subscription <span class="data-source data-source--parkupp"><i class="fa-solid fa-database"></i></span></th>
                            <th>Status</th>
                            <th>Zones</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let tenant of relatedTenants">
                            <td>
                                <code>{{ truncate(tenant.id, 12) }}</code>
                            </td>
                            <td>
                                <strong>{{ tenant.name || 'Unnamed Tenant' }}</strong>
                            </td>
                            <td>
                                <a *ngIf="getSubscriptionFromTenantName(tenant.name)" 
                                   [routerLink]="['/admin/subscription', getSubscriptionFromTenantName(tenant.name)]" 
                                   class="admyt-link">
                                    <i class="fa-solid fa-file-signature"></i>
                                    {{ truncate(getSubscriptionFromTenantName(tenant.name), 10) }}
                                </a>
                                <span *ngIf="!getSubscriptionFromTenantName(tenant.name)" class="text-muted">
                                    <i class="fa-solid fa-unlink"></i> Not linked
                                </span>
                            </td>
                            <td>
                                <span [class]="getStatusClass(tenant.status)">
                                    {{ tenant.status || 'unknown' }}
                                </span>
                            </td>
                            <td>
                                <span *ngIf="tenant.zones && tenant.zones.length > 0">
                                    <span *ngFor="let zone of tenant.zones" class="admyt-status admyt-status--active me-1">
                                        {{ zone }}
                                    </span>
                                </span>
                                <span *ngIf="!tenant.zones || tenant.zones.length === 0" class="text-muted">None</span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <a [routerLink]="['/admin/admyt-center', centerId, 'tenant', tenant.id]" class="btn btn-outline-primary btn-sm" title="View tenant">
                                        <i class="fa-solid fa-eye"></i>
                                    </a>
                                    <a *ngIf="getSubscriptionFromTenantName(tenant.name)" 
                                       [routerLink]="['/admin/subscription', getSubscriptionFromTenantName(tenant.name)]" 
                                       class="btn btn-outline-secondary btn-sm" 
                                       title="View subscription">
                                        <i class="fa-solid fa-file-signature"></i>
                                    </a>
                                    <button class="btn btn-outline-danger btn-sm" title="Deactivate tenant" (click)="deleteTenant(tenant.id)">
                                        <i class="fa-solid fa-ban"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
